(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/exclusion-view-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/exclusion-view-abtest.js');
'use strict';

const ListItem = svs.ui.ReactListGroup.ListItem;
const ExclusionViewAbTest = _ref => {
  let exclusions = _ref.exclusions;
  const date = new Date();
  const oneYearFromNow = new Date();
  oneYearFromNow.setFullYear(date.getFullYear() + 1);
  return React.createElement(React.Fragment, null, React.createElement("h3", {
    className: "align-center f-700 f-bold padding-top-2",
    id: "ongoing-pauses"
  }, "P\xE5g\xE5ende spelpauser"), React.createElement(ListItem, {
    className: "space-list-items",
    key: "vertical"
  }, React.createElement("span", {
    className: "f-bold"
  }, "Spel"), React.createElement("span", {
    className: "right f-bold"
  }, "G\xE4ller till och med")), React.createElement("fieldset", {
    className: "exclusion-pause-wrapper"
  }, React.createElement("legend", {
    "aria-labelledby": "ongoing-pauses",
    className: "question-header-text"
  }), exclusions.map(exclusion => React.createElement(ListItem, {
    "aria-label": "Spel: ".concat(exclusion.subSystem, ", Pausen g\xE4ller till och med:\n               ").concat(new Date(exclusion.expiry).getTime() < oneYearFromNow.getTime() ? exclusion.listFormatDate : 'Tills vidare*'),
    className: "space-list-items",
    key: exclusion.subSystem,
    tabIndex: "0"
  }, React.createElement("span", {
    className: "f-capitalize"
  }, exclusion.subSystem), React.createElement("span", {
    className: "right animate animate-show"
  }, new Date(exclusion.expiry).getTime() < oneYearFromNow.getTime() ? exclusion.listFormatDate : 'Tills vidare*'))), React.createElement("span", {
    className: "fc-black padding-left-1 "
  }, "* "), React.createElement("a", {
    "aria-label": "*L\xE4s mer i Fr\xE5gor och svar",
    className: "padding-top-1 inline-block fc-black",
    href: "#qanda"
  }, "L\xE4s mer i Fr\xE5gor och svar")));
};
svs.selfExclusion.components.ExclusionViewAbTest = ExclusionViewAbTest;

 })(window);